import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import logo from './logo.svg';
import './App.css';
import saga from './project_pictures/saga.png';
import palette from './project_pictures/palette-412w.jpg';
import stats from './project_pictures/6stats-579w.jpg';
// import menu from './project_pictures/menu catalog.PNG';
import old from './project_pictures/old_port.png';
import thisOne from './project_pictures/this.PNG';
import cord from './project_pictures/squiggle-cord.svg';
import sql from './project_pictures/sql.png';
import github from './project_pictures/GitHub-Mark.svg';
import linkedin from './project_pictures/linkedin.png';
import resume from './project_pictures/SiobhanHokin.pdf';
// import'https://use.fontawesome.com/releases/v5.0.10/css/all.css';
//import './bootstrap.min.css';

//

//ok so the below is just a draft of the harmonizing production
// in fact the objective is: continue until all examples of the
// tag have been located. Hence, listing projects by skill seems
// more profitable. except that makes producing the dataset less
// useful. ah instead we need to produce a list, I understand,
// which is then returned.

// it's fun picking a nice word for a variable
// man it time for sleep
// key question: what is the scope for variables in JS and will I
// need to do something weird to get this to work?

function Wires(props){
  const rand = Math.random()
  if (rand<0.33 || props.content=="SQL"){
    return null;
  }
  else if (rand>0.66) {
        return (<div><div className="outer right circle-right">
      <div className="inner circle-right"></div>
      </div></div>)}

  else {
        return (<div><div className="outer left circle-left">
      <div className="inner circle-left"></div>
      </div></div>)
  }
}


function Deets(props){


  const omnia = [
  {name: "saga", description: "Saga is a blogging platform deployed with Google App Engine and built primarily with Python. The user pages are dynamically generated with data from the Google Datastore database, which is updated and requested via GQL, a variant of SQL. User Authentication is fully functional, although not yet secured by SSL.", image: saga, tags: ["HTML5", "Back-end Python", "CSS3", "Design", "SQL"], git: "https://github.com/skehokin/Saga", link: "http://saga-blog.appspot.com"},
  {name: "6stats", description: "6stats was an early for-fun project which generates a random D&D character in JavaScript. Future updates include refactoring and a digitally-painted portrait generator.", image: stats, tags: ["JavaScript"], git: "https://github.com/skehokin/6stats-old", link: "https://skehokin.github.io/6stats-old/"},
  {name: "random palette", description: "This palette generator implements a random-color algorithm in JavaScript to let creatives experiment with a wider variety of color palettes.", image: palette, tags: ["JavaScript"], git: "https://github.com/skehokin/palette-gen", link: "https://skehokin.github.io/palette-gen/"},
  //{name: "menu", description: "This restaurant menu app is dynamically generated from data stored in a mySQL database, and primarily uses the Python Flask web framework on the backend.", image: menu, tags: ["Design", "SQL", "Back-end Python", "HTML5", "CSS3"], git: "", link: ""},
  {name: "This portfolio", description: "This portfolio is a single-page website built entirely with ReactJS.", image: thisOne, tags: ["ReactJS", "CSS3"], git: "a link", link: "a link"},
  {name: "Draft Portfolio", description: "A previous portfolio page, which is simply HTML5 and Bootstrap, with a few enjoyably detailed media queries for responsive design", image: old, tags: ["Design", "HTML5", "CSS3", "Bootstrap"], git: "https://github.com/skehokin/draft-portfolio", link: "https://skehokin.github.io/draft-portfolio/"},
  {name: "Tournament calculator in SQL", description: "This project uses complex SQL queries on a PostgreSQL database to calculate the rounds and store the results of a swiss-style tournament, all conducted within a Vagrant virtual machine.", image: sql, tags: ["Back-end Python", "SQL"], git: "https://github.com/skehokin/swiss-tournament", link: ""}];

  const open = props.open;
  const appraise = search(props.skillName);
  // const onClick = props.onClick;

 if (open){
    return <div className="description">{appraise}</div>;
  }
  else{
    return null;
  }

  function search(tag){
  let final = [];
  omnia.forEach(function(project){
    if (project.tags.indexOf(tag) !== -1){
      var skillButtons = []
      project.tags.forEach(function(each){
        var skillButton = <span className='skill-button'>{each}</span>;
        skillButtons.push(skillButton)
      });
      var newstat = project.name === "6stats" ? <span>A partial rewrite can be viewed <a href="https://github.com/skehokin/6stats-new">here</a>.</span>: "";

      var link = project.link ? <a href={project.link} className='project-links'>project site</a>: "";
      var fullProject = <article className='project'><img src={project.image} alt={project.name} className='project-image'/><a href={project.link}> <h4 className='project-heading'> {project.name} </h4></a><p>{project.description} {newstat}</p> <p>{skillButtons}</p> <p> {link} <a href={project.git} className = "project-links">github repo</a></p></article>;
      final.push(fullProject);
    }

  });
    var close = <p onClick={props.onClick} className="close-but">close</p>;
    final.push (close);
  return final
}
}

// <p onClick={this.handleClick}>close</p>

class Skill extends React.Component {
  constructor(props) {
    super();
    this.state = {
      open: false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  render() {
    return (
      <div
      className="skillbox"
      >
      <h3 className="heading skill-head"
      onClick={this.handleClick}>{this.props.value}</h3>
      <Wires content={this.props.value}/>
      <Deets
      open={this.state.open}
      desc={this.props.desc}
      skillName={this.props.value}
      onClick={(i) => this.handleClick(i)}/>

      </div>);
}


 handleClick() {
this.setState(prevState => ({
      open: !prevState.open
    }));
}

  }


class Skills extends Component {
	constructor(){
		super();
		this.state = {
			skillList:[{"Design": ""},
				{"CSS3": ""},
        {"Bootstrap": ""},
				{"HTML5": ""},
				{"JavaScript": ""},
				{"ReactJS": ""},
				{"Back-end Python": ""},
				{"SQL": ""}]

		}
	};

  render() {

    let buttons=[];
    for (var i=0; i<10; i++){
      buttons.push(<Skill />);
      }
    return (
    <div className="row">
    		<article className="server-rack col-md-12">
        <div className = "cord"><img src={cord} alt="cord" className="cord-image" /></div>
        <h2 className="heading">The Full Stack Server Rack</h2>
        <div className = "cord"><img src={cord} alt="cord" className="cord-image" /></div>
        <section className="skill-list">
         {this.state.skillList.map((thingy, value) =>

           <Skill
           value = {Object.entries(thingy)[0][0]}
           desc = {Object.entries(thingy)[0][1]}
           />
          )}
          </section>
          <div className = "cord"><img src={cord} alt="cord" className="cord-image" /></div>
    		</article>
        </div>
    	);
	}
}


class App extends Component {
  render() {
    return (
      <div className="container-fluid">
        <header className="row">
        <section class="col-md-12 comp-head">
            <h1 className="main-head heading">Let's make this run your business</h1>
          </section>
        </header>

        <Skills/>

        <article className="row">
          <section className="col-md-12 who-am-i">
          <div className="who-content">
          <h1 className="heading who-head">who am i?</h1>
          <p className="who-para"> Siobhan Hokin has been fascinated by programming since she first studied HTML and Visual Basic at 14.</p>
          <p className="who-para"> Having completed a diploma of Graphic Design and Communication, including HTML, CSS and implementing mockups,</p>
          <p className="who-para "> as well as a Bachelor of Arts majoring in Latin and Linguistics,</p>
          <p className="who-para"> she worked as a receptionist in the Sydney-based web development consultancy SSW.</p>
          <p className="who-para"> There, she found her relief from the daily grind in the monthly newsletter, putting together HTML.</p>
          <p className="who-para"> and there she realised that she had been struggling to find her true passion - web development.
          </p>
          </div>
          </section>
        </article>
        <footer className="row">
        <section className="col-md-12 server-rack">
        <hr className="footer-line" />
        <h2 class="heading">Resources</h2>
        <article className = "contact">
        <h3 className = "project-heading">Contact</h3>
        <a href = "https://github.com/skehokin">
          <img src={github} alt = "GitHub logo" className = "logo"/>
        </a>

        <a href="https://www.linkedin.com/in/siobhan-hokin-a1030610b">
          <img src={linkedin} alt = "LinkedIn logo" className = "logo"/>
        </a>
        <p>email: fxrubxva@tznvy.pbz (<a href="http://www.rot13.com/">rot13</a>)</p>
        <p><a href = {resume}>Resum&#233;</a> (PDF)</p>
        </article>
        </section>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js